export function inputPlaceholders(){
    let inputs = $(".with-label");

    inputs.addClass("placeholder-shown");

    inputs.focus(function (){
        $(this).addClass("focus");
    });

    inputs.blur(function (){
        if($(this).val().length == 0){
            $(this).removeClass("focus").addClass("placeholder-shown");
        }
    });

        $( ".datepicker" ).datepicker();

}


// WEBPACK FOOTER //
// ./assets/js/modules/inputs.js